import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Image,
  Text,
} from '@chakra-ui/react';
import React from 'react';
import { MapAccordianItemProps } from '../../interfaces/components';
import { useTranslation } from 'react-i18next';

const MapAccordianItem = ({ image, name, onClick }: MapAccordianItemProps) => {
  const { t } = useTranslation();
  const villageName = name.replaceAll(' ', '_').toLowerCase();

  const onVillageEnter = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <AccordionItem h="auto">
      <h2>
        <AccordionButton>
          <Box display="flex" gap="3" w={['250px', '300px']} alignItems="center">
            <Image src={image} alt="logo" w={['75px', '80px']} h={['75px', '80px']} minW="70px" objectFit="contain" />
            <Text
              fontWeight="800"
              fontSize={['12px', '13px']}
              className="copy"
              fontFamily="SangBleuBPLight"
              w={['100px', '125px']}
              textAlign="left"
            >
              {name}
            </Text>
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel pb={4}>
        <Box
          w="280px"
          p="20px"
          display="flex"
          flexDirection="column"
          gap="3"
          backgroundColor="rgba(255, 255, 255, 1);"
          border="1px solid lightgrey"
        >
          <Text fontWeight="500" fontSize={['12px', '12px']} className="copy" fontFamily="SangBleuBPLight">
            {t(`${villageName.toLowerCase()}_title`)}
          </Text>
          <Text fontWeight="500" fontSize={['14px', '14px']} className="copy" fontFamily="JosefinSans">
            {t(`${villageName.toLowerCase()}_body`)}
          </Text>

          <Button
            bg="white"
            className="copy"
            border="1px solid grey"
            borderRadius="0px"
            py="25px"
            w="100%"
            _hover={{ color: 'white', bg: '#C29F6B', border: '1px solid #C29F6B' }}
            _focus={{ color: 'white', bg: '#C29F6B', border: '1px solid #C29F6B' }}
            mt="2"
            onClick={onVillageEnter}
          >
            <Text fontSize={['14px', '16px', '20px', '20px', '20px']}>ENTER</Text>
          </Button>
        </Box>
      </AccordionPanel>
    </AccordionItem>
  );
};

export default MapAccordianItem;
